import { defineStore } from 'pinia';
import config from '@/config/index.js';

/*
   import { useCounterStore } from '@/store/user'
   const counter = useCounterStore()
   
   // 自动补全！ ✨
   counter.$patch({ count: counter.count + 1 })
   // 或使用 action 代替
   counter.increment()
   
 */
export const useAppStore = defineStore('app',{
	
	state: () => {
		return {
			site: uni.$storage.getJson("site",null) || {
				name: "",
				status: 1,
				avatar: ""
			},
			theme: uni.$storage.getJson("theme","royal-blue"),
			template: uni.$storage.getJson("template",[])
		};
	},
	
	actions: {
		setData(value){
			this.site  = value.site;
			this.theme = value.theme;
			this.template = value.template;
			uni.$storage.setJson("site",value.site);
			uni.$storage.setJson("theme",value.theme);
			uni.$storage.setJson("template",value.template);
		},
		setTheme(name){
			uni.$storage.setJson("theme",name);
		}, 
		getTheme(){
			return this.theme;
		},
		getThemeUrl(){
			return config.request.baseUrl.replace("api","") + "static/template/" + this.theme + "/images/";
		},
		getApp(){
			return this.site;
		},
		setTemplate(name){
			uni.$storage.setJson("template",name);
		},
		getTemplate(){
			return this.template;
		}
	}
	
});